
// host-redirection.guard.ts
import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { LPMI_ROUTES } from '../../constants/routes';
import { isLPMIHost } from '../../util/utils';
import { AuthService } from './auth.service';

export const hostRedirectionGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const host = (window?.location?.hostname || '').toLowerCase();
  const hasToken = !!localStorage.getItem('lpmi.access-token');

  // ---- lpmi → go to PingFederate authorize URL
  const isLpmi = isLPMIHost(host, environment.LPMI_URL);
  if (isLpmi) {
    authService.login('pf', null);
    return false; // cancel Angular route activation
  }

  if (isLpmi && hasToken) {
    // If already authenticated, go to landing
    if (hasToken) {
      return router.navigate(['/' + LPMI_ROUTES.LANDING.PATH]);
    }
  }

  // ---- Default fallback (if you want): send to /login
  return router.navigate(['/' + LPMI_ROUTES.LOGIN.PATH]);
}